import { useGamificationBalance } from "../lib/GamificationBalanceProvider";
import { useSchool } from "../lib/hooks";

import { Image } from "./Image";

export const GamificationBalance: React.FC = () => {
  const gamificationBalance = useGamificationBalance();
  const school = useSchool();

  const gamification = school.gamification;
  if (!gamification) return null;

  return (
    <div className="flex gap-5 align-center">
      <Image
        fit="fill"
        cloudKey={gamification.pointsIconCloudKey}
        width={30}
        height={30}
        resize={{ h: 30, w: 30 }}
      />
      {gamificationBalance}
      <span>{gamification.pointsShortName}</span>
    </div>
  );
};
